import { render, staticRenderFns } from "./SampleSwiper.vue?vue&type=template&id=4400ba0a&scoped=true&"
import script from "./SampleSwiper.vue?vue&type=script&lang=js&"
export * from "./SampleSwiper.vue?vue&type=script&lang=js&"
import style0 from "./SampleSwiper.vue?vue&type=style&index=0&id=4400ba0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4400ba0a",
  null
  
)

export default component.exports